<template>
    <div class="col-md-3 col-sm-6 mb-sm-4 profile-block profile-block--visitx" :class="{'isDefault': advert.isDefault}" :id="id">
        <span @click.prevent="advertClickUrl(advert, advert.isDefault ? '_self' : '_blank', 'native-visitx')"
              class="profile-block-link h-100 cursor-pointer">
            <span class="profile-block-images loaded h-100">
                <div class="visitx-girls-partner-tag" v-if="!advert.isDefault && advert.imageurl">Live cam</div>
                <div v-if="!advert.imageurl" class="visitx-girls-image"></div>
                <div v-else :style="{'background-image': `url('${advert.imageurl}')`}" class="visitx-girls-image"
                     :class="{'visitx-girls-image--default': advert.isDefault}"></div>
            </span>
        </span>

        <span class="profile-block-details">
            <span class="user-details overflow-hidden">
                <span class="heading-1 d-flex">
                    <span class="text-ellipsis">
                        {{ advert.name }}
                    </span>
                </span>
                <span class="user-details-location">
                    <span class="text-ellipsis">
                        {{ advert.aboutme }}
                    </span>
                </span>
            </span>
        </span>
    </div>
</template>

<script>
import {mapState} from "vuex";
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import advertMixin from "@/components/mixins/adverts/advertMixin";
import {incrementNativeAdImpressionCount} from "@/core/utils/helpers/cookieHelper";
import {generateImpressionId} from "@/core/utils/helpers/advertHelper";

const data = () => {
    return {
        id: generateImpressionId(),
        impressionIds: [],
        impressionId: null,
    }
}
function created() {
    this.impressionId = generateImpressionId();
}

function observer() {
    if (this.hideExplicitRegionAds) {
        return;
    }

    const id = this.id;
    if (!id || typeof window === "undefined" || !_.get(this, 'advert.imageurl', _.get(this, 'advert.image_full_link'))) {
        return;
    }
    const advertisement = document.getElementById(id);
    if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!this.impressionIds.includes(id)) {
                        const nativeImpressionCount = incrementNativeAdImpressionCount();
                        this.captureTrackingEvent(this.currentUser, 'search', 'native-ads-impression', 'native-visitx', null, {
                            position: this.advert.position,
                            sch: this.advert.searchId,
                            'impression_id': this.impressionId,
                            'native_impression_count': nativeImpressionCount,
                        })
                        this.impressionIds.push(id);
                    }
                    observer.disconnect();
                }
            });
        }, {
            threshold: 0.5
        });
        observer.observe(advertisement);
    }
}

export default {
    created,
    data,
    computed: {
        ...mapState(['currentUser', 'hideExplicitRegionAds']),
    },
    mixins: [xtrackingMixin, advertMixin],
    props: {
        advert: {
            required: true,
        }
    },
    methods: {
        observer,
    },
    watch: {
        advert: {
            deep: true,
            handler() {
                this.observer()
            }
        },
    },
}
</script>
